export default {
    writeComment: '写评论',
    member: '留下你的评论吧，可@成员',
    sizeMax: '单个大小不超过5M',
    send: '发送',
    comment: '评论',
    noComment: '暂无评论',
    expand: '展开',
    collapse: '收起',
    reply: '回复',
    cancel: '取消',
    sure: '确认',
    imageTips1: '最多可上传8个文件/图片',
    uploadFail: '上传失败',
    imageTips2: '不支持{text}文件',
    moreThan: '大小超过5M',
    sureDeleteComment: '确定删除这条评论吗？',
    deleteCommentSuccess: '删除评论成功!',
    moreReplys: '查看更多{size}条回复 >>',
    replyLoaded: '已显示全部回复',
};
